/**
 * Horizontal padding for main scroll regions under the app shell (client, firm, admin).
 * Matches the responsive header row in `index.css` (`.app-shell-header--row`).
 */
export const shellMainPaddingX = 'px-4 sm:px-6 lg:px-8';
